import { motion, useReducedMotion } from "motion/react";

/** A soft, rounded cloud built from overlapping blobs. */
function Cloud({ scale = 1, tone = 0.9 }: { scale?: number; tone?: number }) {
  return (
    <svg width={180 * scale} height={96 * scale} viewBox="0 0 180 96" style={{ display: "block" }}>
      <g fill="#ffffff" fillOpacity={tone}>
        <ellipse cx="60" cy="60" rx="48" ry="30" />
        <ellipse cx="100" cy="50" rx="42" ry="34" />
        <ellipse cx="132" cy="64" rx="34" ry="24" />
        <rect x="48" y="64" width="100" height="26" rx="13" />
      </g>
    </svg>
  );
}

interface Drifter {
  top: string;
  scale: number;
  tone: number;
  duration: number;
  delay: number;
  from: string;
}

// Deterministic layout so clouds don't reshuffle every render.
const CLOUDS: Drifter[] = [
  { top: "12%", scale: 1.1, tone: 0.85, duration: 70, delay: 0, from: "-20%" },
  { top: "30%", scale: 0.7, tone: 0.6, duration: 95, delay: -30, from: "-10%" },
  { top: "54%", scale: 1.35, tone: 0.7, duration: 60, delay: -15, from: "-30%" },
  { top: "68%", scale: 0.55, tone: 0.5, duration: 110, delay: -55, from: "0%" },
  { top: "82%", scale: 0.9, tone: 0.55, duration: 80, delay: -40, from: "-15%" },
];

/** Morning backdrop: clouds drifting slowly across a bright sky. */
export function Clouds() {
  const reduced = useReducedMotion();

  return (
    <div style={{ position: "absolute", inset: 0, overflow: "hidden" }}>
      {CLOUDS.map((c, i) => (
        <motion.div
          key={i}
          style={{ position: "absolute", top: c.top, left: 0, filter: "blur(0.4px)" }}
          initial={{ x: c.from }}
          animate={reduced ? { x: "40vw" } : { x: ["-25vw", "125vw"] }}
          transition={
            reduced
              ? { duration: 0 }
              : { duration: c.duration, delay: c.delay, ease: "linear", repeat: Infinity, repeatType: "loop" }
          }
        >
          <Cloud scale={c.scale} tone={c.tone} />
        </motion.div>
      ))}
    </div>
  );
}
